import { Box } from "@mui/material";

export const FormDivider = () => <Box sx={{ mt: 1 }} />;
